<template>
<v-form v-model="valid" ref="userCreateForm">
  <v-card-text>
    <v-text-field v-model="name" :label="`${$t('roles.name')}`" required></v-text-field>
    <v-select v-model="permissions" :items="translatedPermissions" :label="`${$t('roles.permissions')}`" attach
              chips item-text="name"
              item-value="value" multiple></v-select>
  </v-card-text>
  <v-divider></v-divider>
  <v-card-actions>
    <v-spacer></v-spacer>
    <v-progress-circular indeterminate color="primary" v-if="loading" spacing="pr-4"></v-progress-circular>
    <v-btn color="primary" @click="create" :disabled="loading">
      {{ $t('base.create') }}
    </v-btn>
  </v-card-actions>
</v-form>
</template>

<script>
import Role from '@/plugins/Role'
export default {
  props: ['allowedPermissions'],
  data() {
    return {
      role: new Role(),
      loading: false,
      valid: false,
      permissions: [],
      name: "",
    }
  },
  computed: {
    translatedPermissions() {
      return this.allowedPermissions.map(permision => ({
        "name": this.role.translatePermission(permision.name),
        "value": permision.name
      }))
    },
    roles() {
      return this.$store.getters.roles
    },
  },
  methods: {
    create() {
      if (this.$refs.userCreateForm.validate()) {
        this.loading = true
        let role = {
          name: this.name,
          permissions: this.permissions,
        }

        this.$http.post("rbac/roles", role).then((data) => {
          this.$store.commit("setSnack", {
            message: this.$t("user.create.success-message", {
              username: this.username
            }),
            color: "success"
          })
          this.$refs.userCreateForm.reset()
          this.$emit("exit", data.data)
        }).catch((err) => {
          let code = err.response.status
          let errMessage = ""

          if (code == 400) {
            errMessage = this.$t("user.create.incorrect-message")
          } else if (code == 403) {
            errMessage = this.$t("user.create.permision-message")
          } else {
            errMessage = this.$t("user.create.unkown-message")
          }

          this.$store.commit("setSnack", {
            message: this.$t(errMessage),
            color: "failed"
          })
        }).finally(() => {
          this.loading = false
        })
      }
    }
  }
}
</script>

<style scoped>
</style>
